import { useMutation } from "@tanstack/react-query";
import { client, type ImageSchema } from "@augmodo/lebron-browser-client";

interface ImageGalleryPayload extends Record<string, unknown> {
  image_ids: string[];
}

interface ImageGalleryResponse {
  images: ImageSchema[];
}

/**
 * React Query hook to fetch images by their IDs using the gallery endpoint
 */
export function useImageGallery() {
  return useMutation({
    mutationFn: async (
      payload: ImageGalleryPayload,
    ): Promise<ImageGalleryResponse> => {
      const response = await client.post({
        url: "/v1/images/gallery",
        body: payload,
        query: {
          page_size: 10000,
        },
      });

      if (response.error) {
        throw new Error(`Failed to fetch image gallery: ${response.error}`);
      }

      return response.data as ImageGalleryResponse;
    },
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {
      console.error("Image gallery fetch failed:", error);
    },
  });
}
